module.exports = __webpack_public_path__ + "static/media/rocket.be1e7a07.svg";